<template>
  <div>
    <footer class="nav-pantone-blue" id="#thefooter">
      <div class="container mt-2">
        <div class="row" v-if="!validationsSocial">
          <div class="col-md-2" v-if="isLoggedIn"></div>
          <div class="col-md-4">
            <br>
            <h4 class="font-weight-light">Kllaar.com</h4>
            <ul class="list-inline options">
              <li class="list-inline-item" @click="scrollTop">
                <router-link to="/atencion-clientes" class="btn mr-2 text-white b-transparent"><i
                  class="fas fa-headset"></i>
                  Atención a Clientes
                </router-link>
              </li>
              <br>
              <li class="list-inline-item" @click="scrollTop('header-terms')">
                <router-link to="/terminos-condiciones" href="" class="btn mr-2 b-transparent"><i
                  class="fas fa-lock"></i> Términos y
                  condiciones
                </router-link>
              </li>
              <br>
              <li class="list-inline-item" @click="scrollTop('header-privacy')">
                <router-link to="/aviso-privacidad" class="btn mr-2 text-white b-transparent"><i
                  class="fas fa-fingerprint"></i> Aviso de privacidad
                </router-link>
              </li>
              <!--<li class="list-inline-item" @click="scrollTop">
                <router-link to="/atencion-clientes" class="btn mr-2 text-white b-transparent"><i
                  class="fas fa-question-circle"></i>
                  Ayuda
                </router-link>
              </li>-->
              <!-- <br v-if="isMobile">
              <li class="list-inline-item">
                <a href="https://blogkllaar.com/" class="btn mr-2 text-white b-transparent" target="_blank"><i
                  class="fas fa-blog"></i>
                  Blog
                </a>
              </li> -->
              <br>
              <li class="list-inline-item" @click="scrollTop('header-about')">
                <a href="/acerca-de" class="btn mr-2 text-white b-transparent"><i class="fas fa-info-circle"></i>
                  Acerca de Kllaar.com
                </a>
              </li>
            </ul>

          </div> 
          <div class="col-md-3"  v-if="!isLoggedIn">
            <div class="__registration mb-4">
              <template v-if="isMobile">
                <h4 class="font-weight-light">¿Qué estás esperando?</h4>
                <h4 class="font-weight-light">Únete a Kllaar.com, tu punto de impulso.</h4>
              </template>
              <template v-else>
                <center>
                  <br><br>
                  <p class="font-weight-light">¿Qué estás esperando?</p>
                  <p class="font-weight-light">Únete a Kllaar.com, tu punto de impulso.</p>
                </center>
              </template>
              <center>
                <router-link to="/registrar/estudiante" class="btn b-orange btn-block">
                Crear una cuenta Kllaar
                </router-link>
              </center>
              
            </div>
          </div>
          <div class="col-md-2"></div>
          <div class="col-md-3"> 
            <template v-if="isMobile">
              <h4 class="font-weight-light">Redes Sociales</h4>
              <h4 class="font-weight-light">Suscríbete y mantente al tanto en nuestras redes.</h4>
            </template>
            <template v-else>
              <br><br>
              <p class="font-weight-light">Redes Sociales</p>
              <p class="font-weight-light">Suscríbete y mantente al tanto en nuestras redes.</p>
            </template>
            <div :class="isMobile ? 'row justify-content-center' : 'row'"> 
                <a href="https://www.facebook.com/Kllaar/" target="_blank">
                  <img src="@/assets/social/__ic_facebook.png" alt="" width="30" class="mx-2">
                </a>
                <a href="https://twitter.com/Kllaar_" target="_blank">
                  <img src="@/assets/social/__ic_twitter.png" alt="" width="30" class="mx-2">
                </a>
                <a href="https://www.instagram.com/kllaar.com_oficial/" target="_blank">
                  <img src="@/assets/social/__ic_instagram.png" alt="" width="30" class="mx-2">
                </a>
                <a href="https://www.youtube.com/channel/UCNufhwngZOWW0oE51Yo43Mw" target="_blank">
                  <img src="@/assets/social/__ic_youtube.png" alt="" width="30" class="mx-2">
                </a>
                <a href="https://www.linkedin.com/company/kllaar" target="_blank">
                  <img src="@/assets/social/__ic_linkedin.png" alt="" width="30" class="mx-2">
                </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
  var VueScrollTo = require('vue-scrollto');

  export default {
    name: 'FooterLarge',
    data() {
      return {
        isMobile: this.$mobile(),  
      }
    },
    computed: {
      isLoggedIn: function () {
        return this.$store.getters.isLoggedIn
      },
      validationsSocial() {
        return this.$store.getters.getValidationSocial
      }
    },
    mounted() {
    },
    methods: {
      scrollTop(to) {
        var cancelScroll = VueScrollTo.scrollTo("#" + to, 500)
      }
    }
  }
</script>

<style scoped lang="scss">
  .options li:hover {
    background: white !important;
    border-radius: 50px;
    transition: all 300ms ease;
  }

  @media screen and (max-width: 500px) {
    footer {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TheFooter.vue